import React, { useState, useEffect } from 'react';
import { getAdminStats } from '../../services/api';
import {
  UsersIcon,
  CurrencyDollarIcon,
  ChartBarIcon,
  BoltIcon,
} from '@heroicons/react/24/outline';

const AdvancedAnalytics = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await getAdminStats();
      if (response.data.success) setStats(response.data.stats);
    } catch (error) {
      console.error('Failed to fetch stats:', error);
    } finally {
      setLoading(false);
    }
  };

  const analyticCards = [
    {
      label: 'Total Users',
      value: stats?.total_users || 0,
      icon: UsersIcon,
      color: 'text-blue-500',
      bg: 'rgba(59, 130, 246, 0.12)',
    },
    {
      label: 'Total Volume',
      value: `$${(stats?.total_deposits || 0).toFixed(2)}`,
      icon: CurrencyDollarIcon,
      color: 'text-emerald-500',
      bg: 'rgba(16, 185, 129, 0.12)',
    },
    {
      label: 'Total P&L',
      value: `$${(stats?.total_pnl || 0).toFixed(2)}`,
      icon: ChartBarIcon,
      color: stats?.total_pnl >= 0 ? 'text-emerald-500' : 'text-rose-500',
      bg: stats?.total_pnl >= 0 ? 'rgba(16, 185, 129, 0.12)' : 'rgba(244, 63, 94, 0.12)',
    },
    {
      label: 'Active Users',
      value: Math.floor((stats?.total_users || 0) * 0.7),
      icon: BoltIcon,
      color: 'text-amber-500',
      bg: 'rgba(245, 158, 11, 0.12)',
    },
  ];

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="text-center">
          <div className="loading-spinner mx-auto mb-4"></div>
          <p className="text-gray-400 text-sm">Loading analytics...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-page fade-in">
      <div className="dashboard-head">
        <h1 className="dashboard-page-title">Advanced Analytics</h1>
        <p className="dashboard-section-subtitle">Insights, platform performance, and quick admin actions</p>
      </div>

      <section className="card dashboard-section">
        <div className="dashboard-section-header">
          <h2 className="dashboard-section-title">Overview Stats</h2>
          <p className="dashboard-section-subtitle">High-level system metrics</p>
        </div>

        <div className="admin-stats-grid">
          {analyticCards.map((stat, index) => (
            <div key={index} className="admin-stat-card">
              <div className="admin-stat-top">
                <div className="admin-stat-icon-wrap" style={{ background: stat.bg }}>
                  <stat.icon className={`h-5 w-5 ${stat.color}`} />
                </div>
              </div>

              <div className="admin-stat-body">
                <p className="admin-stat-label">{stat.label}</p>
                <p className="admin-stat-value">{stat.value}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="card dashboard-section">
        <div className="dashboard-section-header">
          <h2 className="dashboard-section-title">Quick Admin Actions</h2>
          <p className="dashboard-section-subtitle">Frequently used platform controls</p>
        </div>

        <div className="dashboard-section-body">
          <div className="admin-action-grid">
            <button type="button" className="admin-action-btn">
              Export User Data
            </button>
            <button type="button" className="admin-action-btn">
              Send Announcement
            </button>
            <button type="button" className="admin-action-btn">
              Generate Report
            </button>
            <button type="button" className="admin-action-btn danger">
              Maintenance Mode
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AdvancedAnalytics;